const isFunction = input => typeof input === 'function';
export default isFunction;



// WEBPACK FOOTER //
// ./src/core/utils/isFunction.js